export default "__VITE_ASSET__OCvmNGrT__"